/* eslint camelcase: 0 */
import { MonitaroGatewayBase } from './base'
import { toScheduledTalkProps, toScheduledTalkRequest } from './translator/scheduledTalk'
import { toQuery, toQueryProps } from './translator/query'
import { EmptyResponsePropsFactory } from '@/entities/Response'
import { IQueryProps } from '@/entities/Query'
import {
  FetchScheduledTalk,
  FetchAllScheduledTalk,
  PostScheduledTalk,
  PutScheduledTalk,
  DeleteScheduledTalk,
  PutSendScheduledTalk
} from '@/infrastructure/network/Monitaro/requests/scheduled_talk'
import { IScheduledTalkProps } from '@/entities/ScheduledTalk'

export default class ScheduledTalk extends MonitaroGatewayBase {
  async FetchScheduledTalk(room: string, query?: IQueryProps) {
    const response = await this.apiClient.request(new FetchScheduledTalk(room, toQuery(query)))
    return EmptyResponsePropsFactory({
      items: response.scheduled_talks.map((prop) => toScheduledTalkProps(prop)),
      query: toQueryProps(response.query)
    })
  }

  async FetchAllScheduledTalk(query?: IQueryProps) {
    const response = await this.apiClient.request(new FetchAllScheduledTalk(toQuery(query)))
    return EmptyResponsePropsFactory({
      items: response.scheduled_talks.map((prop) => toScheduledTalkProps(prop)),
      query: toQueryProps(response.query)
    })
  }

  async PostScheduledTalk(room: string, params: IScheduledTalkProps) {
    const { scheduled_talk } = await this.apiClient.request(new PostScheduledTalk(room, toScheduledTalkRequest(params)))
    return toScheduledTalkProps(scheduled_talk)
  }

  async PutScheduledTalk(room: string, id: string, params: IScheduledTalkProps) {
    const { scheduled_talk } = await this.apiClient.request(new PutScheduledTalk(room, id, toScheduledTalkRequest(params)))
    return toScheduledTalkProps(scheduled_talk)
  }

  async DeleteScheduledTalk(room: string, id: string) {
    const { scheduled_talk } = await this.apiClient.request(new DeleteScheduledTalk(room, id))
    return toScheduledTalkProps(scheduled_talk)
  }

  async PutSendScheduledTalk(room: string, id: string) {
    const { scheduled_talk } = await this.apiClient.request(new PutSendScheduledTalk(room, id))
    return toScheduledTalkProps(scheduled_talk)
  }
}
